var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-action"},[_c('h2',{staticClass:"display-header"},[_vm._v(_vm._s(_vm.getText('RedirectHeader')))]),_c('hr'),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._v(_vm._s(_vm.getText('RedirectLoadingMessage')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }